/* stylelint-disable max-nesting-depth */
.ux-iws-content-header {
    position: relative;
    text-align: center;
    display: block;

    img {
        @media only screen and (min-width: $tablet) {
            box-shadow: 0 90px 60px -71px rgba(0, 0, 0, 0.08);
        }
    }

    div[slot="image"] {
        font-size: 0;
    }

    &__box {
        background-color: $color-white;
        position: relative;
        z-index: 2;
        padding: 15px 16px;
        transition: all 0.5s ease-in-out;

        @media only screen and (min-width: $tablet) {
            top: -60px;
            padding: 20px 40px;
        }

        @media only screen and (min-width: $desktop-l) {
            top: -100px;
            padding: 40px;
            min-height: 205px;
        }

        @media only screen and (min-width: $desktop-l) {
            &--left {
                background: rgba(255, 255, 255, 0.9);
                bottom: 30px;
                left: 60px;
                top: initial;
                padding: 27px 30px 30px;
                position: absolute;

                h1,
                p {
                    text-align: left;
                }
            }
        }
    }
}

/* stylelint-enable max-nesting-depth */
